import { matchPath } from 'react-router-dom';
import routes, { arrayOfRoutes } from '@ts/containers/App/routes';

const cacheMatches = {};
const registredLoaders = [
    routes.activityPage,
    routes.activityReviewsPage,
    routes.blogPostPage,
    routes.storyPage,
    routes.contentPage,
];

export function isCurrentContainer(path) {
    if (
        matchPath(window.browserHistory.location.pathname, {
            path,
            exact: true,
        })
    ) {
        return true;
    }

    return false;
}

export function matchHref(_href) {
    const href = _href.split('?')[0];
    // Match Route
    for (const { name, path } of arrayOfRoutes) {
        const match = matchPath(href, {
            path,
            exact: true,
        });

        if (match) {
            if (!registredLoaders.includes(match.path)) {
                return false;
            }
            return { route: name, ...match };
        }
    }

    return null;
}

export default function parseLoadable(href) {
    if (typeof href !== 'string') {
        return false;
    }

    if (typeof cacheMatches[href] !== 'undefined') {
        if (cacheMatches[href] && isCurrentContainer(cacheMatches[href].path)) {
            return false;
        }
        return cacheMatches[href];
    }

    const matched = matchHref(href);
    cacheMatches[href] = matched;

    if (!cacheMatches[href]) {
        return false;
    }

    if (isCurrentContainer(cacheMatches[href].path)) {
        return false;
    }

    return cacheMatches[href];
}
